import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

export function QuickView({ row, columns, title, onOpenFull, onClose, testid }) {
  return (
    <Sheet open={Boolean(row)} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="sheet-panel glass w-full overflow-y-auto sm:max-w-md" data-testid={`${testid}-quickview`}>
        {row && <>
          <SheetHeader className="text-left">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-orange-500">Vista rápida</p>
            <SheetTitle className="font-display text-xl">{title(row)}</SheetTitle>
            <SheetDescription>Resumen del registro. Abra la ficha para ver y editar todo.</SheetDescription>
          </SheetHeader>
          <dl className="stagger mt-6 space-y-3">
            {columns.filter((c) => c.label).map((c) => (
              <div key={c.key} className="rounded-lg border border-slate-100 bg-white/70 px-4 py-3">
                <dt className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{c.label}</dt>
                <dd className="mt-1 text-sm text-slate-800">{c.render ? c.render(row) : row[c.key] ?? "—"}</dd>
              </div>
            ))}
          </dl>
          <Button className="mt-6 w-full" onClick={() => onOpenFull(row)} data-testid={`${testid}-quickview-open`}>
            Abrir ficha completa <ArrowUpRight className="ml-2 h-4 w-4" />
          </Button>
        </>}
      </SheetContent>
    </Sheet>
  );
}
